/*
 * Error Service 
 * Author : Kim Tae Oh
 * @errorType : 에러타입별 동작을 정의합니다
 */

import GentleAppState from '../common/appstate';
import GentleWidget from '../common/widget';
import GentleUtil from '../common/util';
import GentleComponentBubble from '../component/bubble';
import GentleLang from '../common/lang';
import language from '../lang';


var GentleServiceError = Object.create( GentleWidget,{
    errorType:{ writable: true, configurable: false, enumerable: true, value:{
        "service":function(){
            // todo 에러메시지 세팅 
            const lang = GentleAppState.lang.toUpperCase();
            this.errorMsg = (lang === GentleLang.lang.KR) ? '앗, 죄송합니다. 오류가 있었습니다. 금방 해결되니 잠시 후에 다시 말씀해주세요.' : "Oh, sorry. There was an error. It will be resolved soon, so please tell me again later.";


            GentleServiceError.createErrorBubble.call(this);
        },
        "system":function(){
            // this.errorPage = '/webchat/error';
            // GentleServiceError.redirectErrorPage.call(this);
        },
        "login":function(){
            this.errorPage = '/webchat/login-error';
            GentleServiceError.redirectErrorPage.call(this);
        }
    }}
});

// 에러객체 초기화 
GentleServiceError.createErrorHandler = function(type, error){

    // 에러타입 검증 
    if(this.errorType[type] === undefined){
        throw new Error('정의되지 않은 에러타입 입니다');
        // console.log('정의되지 않은 에러타입 입니다');
    }

    if(error !== undefined){
        console.error('CustomError', error);
    }
    
    // 에러 서비스 호출 
    this.errorType[type]();

}

// 리다이렉트 
GentleServiceError.redirectErrorPage = function(){
    //console.log(this.errorPage);
    location.href = this.errorPage;
}


// 에러메시지 생성 
GentleServiceError.createErrorBubble = function(){
    
    window.ChatConsole.loadingBox(false);

    // 챗콘솔 자식요소중 stamp가 아니고 resizeSensor가 loadingbox도 아닌 마지막 요소를 찾는다 
    const $errorBubbleSelector = GentleAppState.$chatConsoleSelector.children().not(".speech-date").not(".resize-sensor").not("#loading-box").last();
    
    // 마지막 요소가 에러버블이 아닌경우만 생성 ( 중복생성 회피 )
    if($errorBubbleSelector.data("error") === undefined){

        // 버블생성
        {
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                html: this.errorMsg,
                user: "bot"
            });     
            bubble.setData('error', 'true');
            bubble.insert();   
        }

        // 타임스탬프 
        {
            GentleUtil.timeStamp(); 
        }

    }
    
}

export default GentleServiceError;